import Cookies from 'js-cookie';

const handler = ( $ ) => {

	// show / hide add comment form
	$( document ).on( 'click', '.single-question .comment-reply-link', function( e ) {
		e.preventDefault();

		$(this).parent().find('> .answer-form').toggle('fast');

	});

	// upload the attachment
	$( document ).on( 'click', '.add-attachment-link', function( e ) {
		e.preventDefault();
		$(this).parent().find( '.answer-attachment-file').trigger('click');
	});

	$( document ).on( 'change', '.answer-attachment-file', function( e ) {
		e.preventDefault();

		const $input = $( this ),
		$row = $input.parents('.row-attachment'),
		$addAttachmentLink = $row.find('.add-attachment-link'),
		inputVal = $input.val();

		if( $input[0].files.length > 0 ) {
			$addAttachmentLink.html( inputVal );
		} else {
			$addAttachmentLink.html('Add attachment');
		}

	});

	// submit the comment
	$( document ).on( 'submit', '.single-question .answer-form', function( e ) {
		e.preventDefault();

		let data = new FormData();

		const $form = $(this),
		$errors = $form.find('.error'),
		$file = $form.find('.answer-attachment-file'),
		fileVal = $file.val(),
		post_id = $form.find('input[name=post_id]').val(),
		$content = $form.find('#' + $form.find('input[name=editor_name]').val() ),
		parent_comment_id = $form.find('input[name=parent_comment_id]').val(),
		$fileError = $file.parent().find('.error');

		// auto add https for links without protocol
		let $htmlContent = $('<div />').html( $content.html() );
		
		$htmlContent.find('a').each(function(index, element){

			let $el = $(this),
			href = $el.attr('href');

			if(!href.includes('https://') || !href.includes('http://')){
				$el.attr('href', 'https://' + href );
			}
		});

		const content = $htmlContent.html();

		$errors.hide();

		if( $.trim( content ) == '' ) {
			$content.parent().find('.error').show();
			tinymce.execCommand( 'mceFocus', false, $form.find('input[name=editor_name]').val());
			return false;
		}

		data.append( 'action', 'post_answer');
		data.append( 'nonce', Cookies.get( 'wordpress_pen_ajax_nonce' ));
		data.append( 'content', content );
		data.append( 'post_id', post_id );
		data.append( 'parent_comment_id', parent_comment_id );

		if( $file[0].files.length > 0 ) {

			const ext = fileVal.substr( ( fileVal.lastIndexOf('.') +1) ).toLowerCase();
			const sizeInKb = Math.floor( $file[0].files[0].size / 1024 );

			if( themeVars.question_answer_allowed_file_types.includes( ext ) == false ) {

				$fileError.html('This file type is not supported').show();
				return false;

			} else if ( sizeInKb > 2500 ) {

				$fileError.html('Please choose a file less than 2.5Mb').show();
				return false;

			}

			data.append( 'attachment', $file[0].files[0] );

		}

		$.ajax({
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: data,
			enctype: 'multipart/form-data',
			processData: false,
			contentType: false
		}).done( function( answer ) {

			if( answer.success ) {
				window.location.reload();
			} else {
				alert( answer.data.message );
			}
			

		});

	});

};

export default ( ( $ ) => $( handler ) )( jQuery );
